import React from "react";
import { InputNumber } from "antd";
import { useIntl } from "react-intl";

export default function Limit({ limit = 10000, onUpdate }) {
  const intl = useIntl();
  return (
    <label>
      {intl.formatMessage({
        id: "app.reports.limit",
      })}{" "}
      <InputNumber
        prefix="Limit"
        value={limit}
        step={1000}
        onChange={(value) =>
          onUpdate({
            limit: value,
          })
        }
      />
    </label>
  );
}
